import {ContentEditorActive} from '@packages/shared/states';
import {isRichText} from '@packages/utilities/elementTypeUtils';

export const isEditingCMSOnCanvas = (
  contentEditorState: ContentEditorActive
): boolean => {
  return Boolean(contentEditorState?.item && contentEditorState?.field);
};

export const isEditingDynamicCMSContent = (
  contentEditorState: ContentEditorActive
): boolean => {
  return (
    isEditingCMSOnCanvas(contentEditorState) ||
    Boolean(contentEditorState?.isDataManagerEditing)
  );
};

export type TextInputEditContext =
  | 'component'
  | 'dataManager'
  | 'cms'
  | 'static';

export const getTextInputEditContext = (
  contentEditorState: ContentEditorActive
): TextInputEditContext => {
  if (contentEditorState.componentProp) return 'component';
  if (contentEditorState.isDataManagerEditing) return 'dataManager';
  if (isEditingCMSOnCanvas(contentEditorState)) return 'cms';
  return 'static';
};

export const shouldProfileTextInputLatency = (
  contentEditorState: ContentEditorActive
): boolean => !contentEditorState.fromModal;

export const isEditingRichTextComponentProp = (
  contentEditorState: ContentEditorActive
): boolean => {
  return Boolean(contentEditorState?.componentProp?.type === 'RichText');
};

export const isEditingRichTextComponentPropOverride = (
  contentEditorState: ContentEditorActive
): boolean => {
  return (
    isEditingRichTextComponentProp(contentEditorState) &&
    !isEditingDynamicCMSContent(contentEditorState)
  );
};

export const isNumberEditing = (
  contentEditorState: ContentEditorActive
): boolean => {
  return (
    Boolean(contentEditorState.field?.type === 'Number') ||
    Boolean(contentEditorState.componentProp?.type === 'Number')
  );
};

// Only use plaintext mode (i.e. not able to create format elements etc) if editing a cms item that is not rich text
export const needsContentEditorPlaintextMode = (
  state: ContentEditorActive
): boolean =>
  (Boolean(state.componentProp?.type === 'Number') ||
    isEditingCMSOnCanvas(state)) &&
  !isRichText(state.subtree);
